import { render, staticRenderFns } from "./ListSubheader.vue?vue&type=template&id=6dbe941b&scoped=true"
import script from "./ListSubheader.vue?vue&type=script&lang=js"
export * from "./ListSubheader.vue?vue&type=script&lang=js"
import style0 from "./ListSubheader.vue?vue&type=style&index=0&id=6dbe941b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe941b",
  null
  
)

export default component.exports